import { Injectable } from '@angular/core';
import {Observable} from 'rxjs';

import {HttpService} from '../http.service';

@Injectable({
    providedIn: 'root'
})
export class UserService {

    private userPath = 'user';
    private passwordPath = 'updatepassword';

    constructor(private httpService: HttpService) { }

    getUser(): Observable<any>{
        return this.httpService.httpGet(this.userPath).pipe(response => {
            return response;
        });
    }

    updatePassword(body){
        return this.httpService.httpPut(this.passwordPath, body).pipe(response => {
            return response;
        });
    }

}
